import { widgetApi } from "../services/api";
import { getDeviceSession } from "./seon-session";

/**
 * Resolve a fresh SEON session and POST it to the backend device-session
 * endpoint. Fire-and-forget safe — never throws to the UI.
 */
export async function reportDeviceSession(
  linkId: string | undefined | null,
): Promise<void> {
  if (!linkId) return;
  try {
    const seonSession = await getDeviceSession();
    if (!seonSession) return;
    await widgetApi.post(`/widget/links/${linkId}/device-session`, {
      seonSession,
    });
  } catch {
    /* swallow — device intel must never break the UI */
  }
}

/** Convenience for sensitive steps (provision / create). */
export function maybeReportDeviceSession(
  linkId: string | undefined | null,
): void {
  void reportDeviceSession(linkId);
}
